import { useLanguage } from 'store/locale/hooks/useLanguage'
import LocalizedApp from './LocalizedApp'
import React from 'react'

const RootRedirect = () => {
  const { defaultLanguage } = useLanguage()

  return <LocalizedApp language={defaultLanguage} />
}

export default RootRedirect
